var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.min > 0 || _vm.sec > 0)?_c('span',[_vm._v(_vm._s(_vm.min)+"分"+_vm._s(_vm.sec)+"秒")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }